import { Component, OnInit } from '@angular/core';
import { ThemingService } from 'src/app/theming.service';
import { SettingsService } from 'src/app/settings.service';
import { LambdaService } from 'src/app/lambda.service';
import { ApiService } from 'src/app/api.service';
declare var $: any;

interface Resource {
  resourceId: string;
  resourceName: string;
  timekitResourceId: number;
  shopId: number;
}

@Component({
  selector: 'app-timekit-resources',
  templateUrl: './timekit-resources.component.html',
  styleUrls: ['./timekit-resources.component.scss']
})

export class TimekitResourcesComponent implements OnInit {
  showNoResourcesMessage: boolean = false;
  resources: any[] = [];
  loading: boolean = false;
  timekitResourceId: number = 0;
  editingResourceId: string | null = null;

  constructor(
    public themingService: ThemingService,
    private settingsService: SettingsService,
    private lambdaService: LambdaService,
    private apiService: ApiService,
  ) {
    this.settingsService.getListingResources$().subscribe((isActive) => {
      if (isActive) {
        this.getTimekitResources();
      }
    });
  }

  ngOnInit(): void {
    this.getTimekitResources()
  }

  async getTimekitResources() {
    this.loading = true;
    this.showNoResourcesMessage = false;

    try {
      const response = await this.lambdaService.getTimekitResources(this.themingService.shopId) as { data: { resourceId: string, resourceName: string }[] };
      this.resources = response.data || [];

    } catch (error) {
      console.error('Error al obtener recursos:', error);
      this.resources = [];
    } finally {
      this.loading = false;
    }
  }

  updateResource(resourceId: string, timekitResourceId: number, resourceName: string, shopId: number) {
    this.apiService.updateResource(resourceId, timekitResourceId, resourceName, shopId)
      .then((res: any) => {
        const body = typeof res.body === 'string' ? JSON.parse(res.body) : res.body;

        if (body?.error || res.statusCode !== 200) {
          this.showErrorModal();
          return;
        }

        this.getTimekitResources();
        $('#successUpdateResourceModal').modal('show');
      })
      .catch((error) => {
        console.error('Error al actualizar el recurso:', error);
        this.showErrorModal();
      });
  }

  cancelEdit(): void {
    this.editingResourceId = null;
  }

  async saveEdit(resource: any): Promise<void> {
    const { resourceId, timekitResourceId, resourceName } = resource;
    const shopId = this.themingService.shopId;

    try {
      await this.updateResource(resourceId, timekitResourceId, resourceName, shopId);
      $('#successEditResourceModal').modal('show');
      this.editingResourceId = null;
    } catch (err: any) {
      console.error('Error al actualizar recurso:', err);
      $('#errorEditResourceModal').modal('show');
    }
  }

  deleteResources(resourceId: string, timekitResourceId: number) {
    this.apiService.deleteTimekitResource(resourceId, timekitResourceId, this.themingService.shopId)
      .then((res: any) => {
        const body = typeof res.body === 'string' ? JSON.parse(res.body) : res.body;

        if (body?.error || res.statusCode !== 200) {
          console.warn('Error lógico en respuesta:', body);
          this.showErrorModal();
          return;
        }

        this.getTimekitResources();
        $('#successDeleteResourceModal').modal('show');
        $('#successDeleteResourceModal').on('hidden.bs.modal', () => { });
      })
      .catch((error) => {
        console.error('Error en petición al eliminar recurso:', error);
        this.showErrorModal();
      });
  }

  setCreatingResources() {
    this.settingsService.setCreatingResources();
  }

  showErrorModal(): void {
    $('#errorDeleteResourceModal').modal('show');
    $('#errorDeleteResourceModal').on('hidden.bs.modal', () => {
    });
  }

  closeModal() {
    $('#requiredProjectModal').modal('hide');
    $('#errorDeleteResourceModal').modal('hide');
    $('#errorEditResourceModal').modal('hide');
  }

  closeSuccessModal() {
    $('#successDeleteResourceModal').modal('hide');
    $('#successEditResourceModal').modal('hide');
  }

}
